"use client";
import { MENU_KEYS } from "@/constants";
import pulseConfig from "@/pulsex.config";
import {
    faFacebook,
    faInstagram,
    faTelegram,
    faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMenus, useResponsive } from "@pulsex/hooks";
import * as React from "react";

export default function Footer({ isMobile }) {
    const { menus } = useMenus(pulseConfig);
    const footerMenu = menus?.getMenuByKey(MENU_KEYS.FOOTER);

    return (
        <footer className="bg-[#e1e1e1] py-6 px-0 overflow-hidden">
            <div className="container mx-auto ">
                <div className="flex items-center gap-6 lg:items-end">
                    <img src="/images/logo.webp" alt="logo" className="w-28" />

                    {!isMobile && (
                        <div className="flex gap-8 items-center">
                            {footerMenu?.map((m) => (
                                <a
                                    key={m.title}
                                    href={m.url ?? "#"}
                                    className="font-semibold text-[#6B7074] "
                                >
                                    {m.title}
                                </a>
                            ))}
                        </div>
                    )}

                    <div className="flex gap-4 ml-auto">
                        <a
                            href="https://twitter.com/MayadeenEnglish"
                            className="text-primary lg:text-gray-400"
                        >
                            <FontAwesomeIcon
                                icon={faXTwitter}
                                size={isMobile ? "lg" : "xl"}
                            />
                        </a>
                        <a
                            href="https://t.me/almayadeenenglish"
                            className="text-primary lg:text-gray-400"
                        >
                            <FontAwesomeIcon
                                icon={faTelegram}
                                size={isMobile ? "lg" : "xl"}
                            />
                        </a>
                        <a
                            href="https://www.facebook.com/almayadeenenglish?ref=page_internal"
                            className="text-primary lg:text-gray-400"
                        >
                            <FontAwesomeIcon
                                icon={faFacebook}
                                size={isMobile ? "lg" : "xl"}
                            />
                        </a>
                        <a
                            href="https://www.instagram.com/almayadeenenglish/"
                            className="text-primary lg:text-gray-400"
                        >
                            <FontAwesomeIcon
                                icon={faInstagram}
                                size={isMobile ? "lg" : "xl"}
                            />
                        </a>
                    </div>
                </div>

                <div className="h-px bg-primary/60 my-6" />

                {isMobile && (
                    <>
                        <div className="flex gap-8 items-center lg:justify-between lg:gap-3 lg:flex-wrap">
                            {footerMenu?.map((m) => (
                                <a
                                    key={m.title}
                                    href={m.url ?? "#"}
                                    className="font-semibold text-[#6B7074] "
                                >
                                    {m.title}
                                </a>
                            ))}
                        </div>
                        <div className="h-px bg-primary/60 my-6" />
                    </>
                )}

                <p className="font-bold text-[#616161] mb-2 text-lg lg:text-sm">
                    Al Mayadeen is an independent Arab Media Network.
                </p>
                <p className="text-sm text-[#6B7074] ">All rights reserved</p>
            </div>
        </footer>
    );
}
